// requires videotranscripts.js
const prodVideoPage = function () {
	const productScroller = new prodScroller();
	const videoTranscripts = new videoTranscripts4i();
	const common = new videoCommon();
	const starRatingJS = new StarRating4i();
	
	const init = () => {
      		const newVids = document.getElementById("newVideos");
		const hotVids = document.getElementById("hotVideos");
		const saleVids = document.getElementById("saleVideos");
		if(newVids !== null) productScroller.Init("newVideos", 5, 4, 3); //numbers are # items shown per breakpoint
		if(hotVids !== null) productScroller.Init("hotVideos", 5, 4, 3);
		if(saleVids !== null) productScroller.Init("saleVideos", 5, 4, 3);
		
		const allVideoLinks = [].slice.call(document.querySelectorAll(".videoLink"));
		for(let i = 0; i < allVideoLinks.length; i++){
			allVideoLinks[i].addEventListener("mouseover", makeTransparent);
			allVideoLinks[i].addEventListener("mouseout", undoTransparent);
		}
		
      		videoTranscripts.Init();
      		starRatingJS.Init();
      		common.ShowFromDialog();
      		
      		setTimeout(() => { common.AddLinks(); }, 300);
	};
	
	const makeTransparent = (e) =>{
		const el = e.currentTarget;
		const itemImage = el.querySelector(".thumbImg");
		itemImage.style.opacity = "0.3"; 
	};
	
	const undoTransparent = (e) =>{
		const el = e.currentTarget;
		const itemImage = el.querySelector(".thumbImg");
		itemImage.style.opacity = "1";
	};

	return{
		Init: init
	};
};

(async () => {
	const productVidPage = new prodVideoPage();
	productVidPage.Init();
})();